<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onRowItemClick">

            <template v-slot:[`item.updatedAt`]="{ item }">
                <span>
                    {{ $util.getDDMMYYYYHHSSDateFormat(item.updatedAt) }}
                </span>
            </template>

            <template v-slot:[`item.bannerUrl`]="{ item }">
                <img
                    v-if="item.bannerUrl"
                    style="width: 200px; height: auto;"
                    class="my-4"
                    :src="item.bannerUrl"
                    alt="banner"/>
                <div v-else>
                    No Image Provided
                </div>
            </template>

            <template v-slot:[`item.isActive`]="{ item }">
                <v-chip
                    :color="item.isActive ? 'success': ''">
                    {{ item.isActive ? 'Active' : 'Inactive' }}
                </v-chip>
            </template>
            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import { TableMixinFactory } from '@/mixins/TableMixin'

export default {
    name: 'BookingTable',

    components: {
        BaseTable
    },

    mixins: [
        TableMixinFactory({
            itemMapFunc: function (item) {
                return {
                    ...item
                }
            }
        })
    ],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('bannerList.table.header.settingDate'),
                    value: 'updatedAt',
                    width: '160px',
                    sortable: false
                },
                {
                    text: this.$t('bannerList.table.header.banner'),
                    value: 'bannerUrl',
                    sortable: false
                },
                {
                    text: this.$t('bannerList.table.header.link'),
                    value: 'link',
                    sortable: false
                },
                {
                    text: this.$t('bannerList.table.header.status'),
                    value: 'isActive',
                    sortable: false
                },
                {
                    text: '',
                    value: 'action',
                    align: 'right',
                    sortable: false
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
